import React, { useEffect, useState } from 'react';
import CenterSpinner from '../../components/CenterSpinner';
import { Label } from 'reactstrap';
import KTable from '../../components/KTable';
import KPagination from '../../components/KPagination';
import {
  AttendanceFilterType,
  AttendanceItemType,
  ColumnHeaderType,
  LoggedUserType,
  PaginationType,
  UserType,
} from '../../utils/Types';
import {
  API_STATUS,
  DEFAULT_OPTION,
  DEFAULT_OPTION_LOCATION,
  DEFAULT_PAGE_SIZE,
} from '../../utils/Constant';
import { useNavigate } from 'react-router-dom';
import AttendanceModal from '../modals/AttendanceModal';
import AttendanceFilter from '../../filters/AttendanceFilter';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import {
  attendanceSelector,
  clearApprovedRejectedStatus,
  clearAttendanceDetails,
  fetchAttendanceList,
} from '../../features/attendanceSlice';
import {
  getAttendanceRequestParam,
  onTableAction,
  VIEW_ATTENDEES_HEADER,
} from './ViewAttendeesPageHelper';
import { loginSelector } from '../../features/loginSlice';

const ViewAttendeesPage: React.FunctionComponent = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState<number>(DEFAULT_PAGE_SIZE);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const navigate = useNavigate();

  const [selectedFilter, setSelectedFilter] = useState<AttendanceFilterType>({
    candidateId: '',
    employeeName: '',
    zone: DEFAULT_OPTION_LOCATION,
    state: DEFAULT_OPTION_LOCATION,
    city: DEFAULT_OPTION_LOCATION,
    district: DEFAULT_OPTION_LOCATION,
    role: DEFAULT_OPTION,
    fromDate: new Date(),
    toDate: new Date(),
    isCsv: false,
    status: DEFAULT_OPTION,
  });
  const [selectedUser, setSelectedUser] = useState<any>();
  const dispatch = useAppDispatch();
  const attendanceList: AttendanceItemType[] =
    useAppSelector(attendanceSelector).attendanceData.attendanceList;
  const pagination: PaginationType =
    useAppSelector(attendanceSelector).attendanceData.pagination;
  const apiStatus = useAppSelector(attendanceSelector).apiProgressStatus;
  const user: LoggedUserType = useAppSelector(loginSelector).user;
  const userDetails: UserType = useAppSelector(loginSelector).userDetails;

  const findAttendanceData = (filter: AttendanceFilterType) => {
    dispatch(
      fetchAttendanceList(
        getAttendanceRequestParam(
          filter,
          currentPage,
          pageSize,
          user,
          userDetails
        )
      )
    );
  };
  useEffect(() => {
    findAttendanceData({
      ...selectedFilter,
      isCsv: false, // ✅ force false on pagination change
    });
  }, [currentPage, pageSize, user, userDetails]);

  useEffect(() => {
    if (apiStatus && apiStatus === API_STATUS.LOADING) {
      setShowLoader(true);
    } else {
      setShowLoader(false);
    }
  }, [apiStatus]);

  const toggleModal = (action: string) => {
    dispatch(clearAttendanceDetails());
    dispatch(clearApprovedRejectedStatus());
    findAttendanceData({ ...selectedFilter, isCsv: false });
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div className="ml-4">
      <Label className="text-heading">View Attendees</Label>
      <AttendanceFilter
        onApplyFilters={(filter: AttendanceFilterType) => {
          setSelectedFilter(filter);
          findAttendanceData(filter);
        }}
      />
      <div className="mt-4">
        <KTable
          data={attendanceList}
          columnHeader={VIEW_ATTENDEES_HEADER}
          onAction={(param: AttendanceItemType, header: ColumnHeaderType) => {
            onTableAction(
              param,
              header,
              isModalOpen,
              setSelectedUser,
              setIsModalOpen,
              navigate,
              dispatch
            );
          }}
          tableParentClass="table-parent-view-attendance"
          isLoading={showLoader}
        />
        {attendanceList && attendanceList.length > 0 && (
          <KPagination
            totalPages={pagination?.totalPages}
            currentPage={pagination?.currentPage}
            pageSize={pagination?.pageSize}
            onPageChange={setCurrentPage}
            onSizeChange={setPageSize}
            fromItem={pagination?.fromItem}
            toItem={pagination?.toItem}
            totalItems={pagination?.totalItems}
          />
        )}
      </div>
      {isModalOpen && (
        <AttendanceModal
          isOpen={isModalOpen}
          toggleModal={toggleModal}
          selectedUser={selectedUser}
        />
      )}
      <CenterSpinner showLoader={showLoader} className="spinner-60" />
    </div>
  );
};

export default ViewAttendeesPage;
